/* eslint-disable react/no-danger */
import * as React from "react";
import { useTranslation } from "react-i18next";

import { GET_CONTENT } from "../../../graphql/query";
import { Content } from "../../../models/content";
import Button from "../../Button";
import { useLocale } from "../../../context/LocaleContext";
import { useFetcher } from "../../../hooks/useClientFetcher";

interface Props {
  onBack: () => void;
}

const UsageConsent: React.FC<Props> = ({ onBack }) => {
  const { t } = useTranslation("common");
  const locale = useLocale();
  const [_getContent, { data }] = useFetcher<{
    content: Content[]
  }>(GET_CONTENT, {
    variables: {
      locale,
      namespace: "contents",
      key: "terms.usage",
    },
  });

  return (
    <div className="flex-row" data-pw="usageConsent">
      {data && (
        <div
          className="px-6"
          dangerouslySetInnerHTML={{ __html: data.content[0].content || "" }}
        />
      )}
      <div className="text-center">
        <Button
          render="primary"
          size="large"
          type="button"
          className="mx-6 mt-9"
          onClick={onBack}
          data-pw="usageConsentSubmit"
        >
          {t("back")}
        </Button>
      </div>
    </div>
  );
};

export default UsageConsent;
